// Map #5 Glacier Ruins, audio half. Frozen plains around a fallen colonnade at dawn.
// Ambience: whistling icy wind over a deep low wind body and fine snow hiss (all three surge in the whiteout gust), ice
// cracking and groaning, the odd 'singing ice' zing, icicles tinkling, a glacier shifting far off, and distant howls (more
// at night, sometimes two at once). Cold, long echo.
// Music: D minor elegy in 12/8 (66 bpm): a wide saw pad over a low drone, glass-bell arps, a breathy flute lead, distant
// taiko that gathers when the boss is out.
import { MODES, type MapAudioDef } from '../../audio/mapAudioDef';

export const AUDIO: MapAudioDef = {
  id: 'glacier-ruins',
  ambience: {
    level: 0.79,
    beds: [
      { src: 'pink', filter: 'bandpass', freq: 1100, q: 1.1, gain: 0.4, storm: 2.5, gust: { depth: 0.7, every: [2, 6], sweep: 2 } },
      { src: 'brown', filter: 'lowpass', freq: 260, gain: 0.5, storm: 1.5, gust: { depth: 0.4, every: [3, 8] } },
      { src: 'white', filter: 'highpass', freq: 5000, gain: 0.04, storm: 3, gust: { depth: 0.6, every: [1.5, 4] } },
    ],
    events: [
      { kind: 'crack', every: [8, 18], gain: 0.18, echo: 0.4 },
      { kind: 'icezing', every: [18, 40], gain: 0.06, echo: 0.6 },
      { kind: 'creak', every: [12, 25], gain: 0.07, pitch: 0.6, echo: 0.5 },
      { kind: 'howl', every: [25, 50], gain: 0.07, day: 0.4, night: 1, echo: 0.7, voices: 2 },
      { kind: 'gust', every: [6, 12], gain: 0.3, storm: 1.5 },
      { kind: 'chime', every: [15, 30], gain: 0.04, pitch: 1.6, echo: 0.5 },
      { kind: 'rumble', every: [30, 60], gain: 0.2 },
    ],
    echo: { l: 0.37, r: 0.53, fb: 0.5, damp: 2600, wet: 0.75 },
  },
  music: {
    mood: 'frozen elegy (D minor, 12/8 at 66 bpm)',
    score: {
      bpm: 66, steps: 12, root: 50, mode: MODES.aeolian, progression: [0, 5, 3, 4, 0, 5, 6, 4],
      pad: { wave: 'sawtooth', voices: 4, detune: 14, cutoff: 1100, gain: 0.07, octave: 1, send: 0.45 },
      drone: { wave: 'sine', notes: [0, 7], cutoff: 500, gain: 0.05, octave: -1 },
      bass: { wave: 'sine', cutoff: 500, atk: 0.05, dec: 0.6, sus: 0.7, rel: 0.5, gain: 0.36, octave: -1,
        pattern: '1-----5-----', hot: '1--1--5--5--' },
      arp: { wave: 'sine', fm: { ratio: 2.76, index: 1, decay: 0.3 }, cutoff: 7000, atk: 0.002, dec: 0.8, sus: 0, rel: 0.6, gain: 0.08, octave: 2, send: 0.6, legato: 1.5,
        pattern: [0, -1, -1, 2, -1, -1, 4, -1, -1, 2, -1, -1], hot: [0, -1, 2, 4, -1, 2, 3, -1, 2, 4, -1, 2] },
      lead: { wave: 'sine', cutoff: 3000, atk: 0.08, dec: 0.5, sus: 0.8, rel: 0.5, gain: 0.12, octave: 1, send: 0.6,
        vibrato: { rate: 4.5, cents: 22 }, bars: [2, 6],
        motifs: [
          { notes: [[4, 6], [3, 3], [2, 3], [0, 9], [null, 3]] },
          { notes: [[2, 3], [4, 3], [5, 6], [4, 3], [2, 3], [1, 6]] },
          { notes: [[7, 9], [6, 3], [4, 6], [null, 6]] },
        ] },
      drums: { kit: 'taiko', gain: 0.85,
        main: { kick: 'X...........', tom: '......x.....' },
        fill: { tom: '......x..xxX' },
        hot: { kick: 'X.....X.....', tom: '...x.....xxX', snare: '.........x..', hat: 'x..x..x..x..' } },
      echo: { steps: 3, fb: 0.45, wet: 0.3, damp: 2500 },
      level: 0.52,
    },
  },
};
